import { NotFound } from "#app/components/layout/NotFound";

export default function NotFoundRoute() {
  return <NotFound />;
}
